import { FC } from 'react';
import { CreateTeamFields } from './types';
import { createTeamSchemaValidation } from './createTeamValidation';
import { useAppDispatch } from 'lib/redux';
import { ButtonSubmitDomain } from './teamDomain';
import { updateTeamDomain } from '../teamSlice';
import { useRouter } from 'next/router';
import { Field, FieldProps, Form as FormikForm, Formik } from 'formik';
import { FormControl, Input, InputGroup, InputLeftElement, Stack } from '@chakra-ui/react';
import { BaseIcons, getIcon } from 'lib/icons';

type Props = {
  identifier: string;
  teamName: string;
};

export const CreateTeamForm: FC<Props> = ({ identifier, teamName }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const onSubmit = async ({ subdomain }, { setSubmitting }) => {
    // We don't have to do anything, as there's no change to the team identifier
    if (subdomain === identifier) {
      router.push('/register/subscribe');
      return;
    }

    try {
      await dispatch(
        updateTeamDomain({
          team: { name: teamName, identifier: subdomain },
          originalIdentifier: identifier,
          setSubmitting,
        })
      ).unwrap();
      return router.push('/register/subscribe');
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{ subdomain: identifier }}
      validateOnMount={true}
      validationSchema={createTeamSchemaValidation}
      onSubmit={onSubmit}
    >
      <FormikForm className="form">
        <Stack spacing={6} className="form__stack">
          <Field key="subdomain" name="subdomain" className="form-field__wrapper">
            {({ field, form, meta }: FieldProps) => (
              <FormControl
                isInvalid={Boolean(meta.touched && form.errors[field.name])}
                isRequired={true}
                className="form-field__control"
              >
                <InputGroup size="md">
                  <InputLeftElement height="100%" width="30px" ml="15px">
                    {getIcon(BaseIcons.Person)}
                  </InputLeftElement>
                  <Input
                    pr="2rem"
                    pl="4rem"
                    size="lg"
                    name="subdomain"
                    type="text"
                    placeholder="Enter your custom team subdomain"
                    spellCheck="false"
                    autoFocus={true}
                    {...field}
                    onChange={(event) => {
                      let subdomain = event.target.value.toLowerCase();

                      subdomain = subdomain.replace(/ /g, '-');
                      subdomain = subdomain.replace(/[^a-z0-9-]/g, '');

                      form.setFieldValue('subdomain', subdomain);
                    }}
                  />
                </InputGroup>
              </FormControl>
            )}
          </Field>
          <ButtonSubmitDomain />
        </Stack>
      </FormikForm>
    </Formik>
  )
}
